module.exports = __webpack_public_path__ + "static/TSP_Logo-0934af78df95494951cfc58121eeee6b.jpg";